import useKeyPressEvent from "react-use/lib/useKeyPressEvent";
import determineVisiblePages from "lib/reducers/search/determineVisiblePages"
import styles from './pagination.module.css'

import {
  Paging,
} from "@elastic/react-search-ui";
import { usePathname } from "next/navigation";

type Props = {
  currentPage: number,
  setCurrentPage: any
}

const Pagination = ({ currentPage, setCurrentPage }: Props) => {
  let router = usePathname();

  return (
    <Paging view={({ totalPages, onChange }) => {
      if (totalPages === 1) {
        return null;
      }
      useKeyPressEvent("ArrowLeft", (e) => {
        if (currentPage !== 1) {
          onChange(currentPage - 1);
          window.scrollTo(0, 0);
        }
      });
      useKeyPressEvent("ArrowRight", (e) => {
        if (currentPage !== totalPages) {
          onChange(currentPage + 1);
          window.scrollTo(0, 0);
        }
      });
      useKeyPressEvent("ArrowUp", (e) => {
        if (currentPage !== totalPages) {
          onChange(currentPage + 1);
          window.scrollTo(0, 0);
        }
      });
      useKeyPressEvent("ArrowDown", (e) => {
        if (currentPage !== 1) {
          onChange(currentPage - 1);
          window.scrollTo(0, 0);
        }
      });

      const pages: {index:number}[] =[]
      for (let i = 1; i <= (totalPages); i++) {
        pages.push({ index: i })
      }


      const basePath = router?.split('?', 2)[0];

      const { visiblePages } = determineVisiblePages(currentPage, pages);
      return (
        <ul className={styles.Inner}>
          <li className={`${styles.bookend} ${styles.li}  ${styles.leftDouble}`}>
            <a className={styles.link}
              aria-label="Previous page"
              href={basePath}
              onClick={(e) => {
                if (e.cancelable) e.preventDefault();
                if (currentPage > 1) {
                  onChange(1);
                  setCurrentPage(1);
                  window.scrollTo(0, 0);
                }
              }}
            > <span>&#60; &#60;</span> </a>
          </li>
          <li className={`${styles.bookend} ${styles.li} ${styles.left}`}>
            <a className={styles.link}
              aria-label="Previous page"
              rel="prev"
              href={`${basePath}${(currentPage || 1) !== 1 ? `?current=n_${currentPage - 1}_n` : ''}`}
              onClick={(e) => {
                if (e.cancelable) e.preventDefault();
                if (currentPage > 0) {
                  onChange(currentPage - 1);
                  setCurrentPage(currentPage - 1);
                  window.scrollTo(0, 0);
                }
              }} > 	<span>&#60;</span> </a>
          </li>

          {visiblePages.map((index: number) => {
            const active = Number(currentPage) === index;
            return (
              <li key={index} className={active ? `${styles.active} ${styles.li}` : styles.li}>
                <a className={styles.link} href={index !== 1 ? `${basePath}?current=n_${index}_n` : basePath} onClick={(e) => {
                  if (e.cancelable) e.preventDefault();
                  if (!active) {
                    onChange(index);
                    setCurrentPage(index);
                    window.scrollTo(0, 0);
                  }
                }}
                >
                  {index}
                </a>
              </li>
            );
          })}

          <li className={`${styles.bookend} ${styles.right}  ${styles.li}`}>
            <a className={styles.link}
              aria-label="Next page"
              rel="next"
              href={`${basePath}${currentPage !== totalPages ? `?current=n_${currentPage + 1}_n` : ``}`}
              onClick={(e) => {
                if (e.cancelable) e.preventDefault();
                if (currentPage < totalPages) {
                  onChange(currentPage + 1);
                  setCurrentPage(currentPage + 1);
                  window.scrollTo(0, 0);
                }
              }}
            > 	<span>&#62;</span>  </a>
          </li>
          <li className={`${styles.bookend} ${styles.rightDouble}  ${styles.li}`}>
            <a className={styles.link}
              aria-label="Last page"
              href={`${basePath}${currentPage !== totalPages ? `?current=n_${totalPages}_n` : ``}`}
              onClick={(e) => {
                if (e.cancelable) e.preventDefault();
                if (currentPage < totalPages) {
                  onChange(totalPages);
                  setCurrentPage(totalPages);
                  window.scrollTo(0, 0);
                }
              }}
            > <span>&#62;&#62;</span>  </a>
          </li>
        </ul>

      )
    }} />
  )
};

export default Pagination;
